<template>
  <div>
    <iframe v-show="false" :src="shibLogoutUrl" width="0px" height="0px" scrolling="no" />
    <div class="login-panel">
      <div class="login-panel-head">
        <h1><i class="kricon fa fa-id-card-o"></i><h1>KMR<span> - Kártya menedzsment rendszer</span></h1></h1>
        <p>A Széchenyi István Egyetem kártya menedzsment felülete.</p>
      </div>
      <div class="login-panel-body">
        <h2>Kijelentkezés</h2>
        <p>Ön sikeresen kijelentkezett rendszerükből.</p>
        <router-link :to="{ path: '/login' }" class="btn btn-primary">Szeretnék újra bejelentkezni</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
    }
  },computed: {
    shibLogoutUrl: function() {
      return location.protocol+"//"+location.host+"/Shibboleth.sso/Logout";
    }
  },
  mounted: function() {
    var _this = this;

    this.$root.ajax('users/logout', {
      method: 'POST',
      data: this.form,
      success: function(response) {
        _this.$root.$data.user = {};
        //_this.$router.push({path: '/login'});
      }
    });
  }
}
</script>


// WEBPACK FOOTER //
// logout.vue?8c4a4bd6